import { refundMethods } from '@reveni-io/reveni-ui'

export const refundMethodsLabels = {
  [refundMethods.originalPaymentMethod]: 'Método de pago original',
  [refundMethods.storeCredit]: 'Crédito en tienda',
  [refundMethods.giftCard]: 'Tarjeta regalo',
  [refundMethods.bankTransfer]: 'Transferencia bancaria',
}
